import { NoteCreateTileType } from '@nx-frontend/shared/types';
import { PageTemplateSelect } from './page-template-select';

export function EntityTemplateSelect({
  entityType,
  changeTemplateId,
}: {
  entityType: string;
  changeTemplateId: (templateId: NoteCreateTileType | null) => void;
}) {
  if (entityType === 'page') {
    return <PageTemplateSelect changeTemplateId={changeTemplateId} />;
  } else {
    return null;
  }
}
